<template>
  <div class="clickNum">
    <div class="tools">
      <div class="title">点击次数统计图</div>
      <div class="tool">
        <MSelect :options="selectOption" v-model="bindQuery"></MSelect>
      </div>
    </div>
    <div class="clickCharts">完蛋，ehcarts没加载出来。。。</div>
  </div>
</template>

<script>
import * as echarts from "echarts/core";
import { GridComponent } from "echarts/components";
import { LineChart } from "echarts/charts";
import { TooltipComponent } from "echarts/components";
import { UniversalTransition } from "echarts/features";
import { CanvasRenderer } from "echarts/renderers";
import MSelect from "@/components/common/Select/Select.vue";
echarts.use([
  GridComponent,
  TooltipComponent,
  LineChart,
  CanvasRenderer,
  UniversalTransition,
]);

import { getDays } from "@/api/user";
export default {
  props: {},
  components: {
    MSelect,
  },
  data() {
    return {
      myChart: null,
      option: {
        annimation: true,
        xAxis: {
          type: "category",
          name: "日期/月-日",
          data: [],
        },
        yAxis: {
          type: "value",
          name: "调用次数/次",
        },
        series: [
          {
            data: [],
            type: "line",
            smooth: true,
          },
        ],
        tooltip: {
          trigger: "item",
          formatter: "{b}点击次数:{c}",
        },
      },
      bindQuery: 1,
      selectOption: [
        {
          name: "近三天",
          value: 0,
        },
        {
          name: "近7天",
          value: 1,
        },
        {
          name: "近14天",
          value: 2,
        },
        {
          name: "近30天",
          value: 3,
        },
        {
          name: "本月",
          value: 4,
        },
      ],
    };
  },
  watch: {
    bindQuery: function (val) {
      this._getDatas([3, 7, 14, 30, 16][val]);
    },
    "$store.getters.getMenuOpen": function () {
      this.onResize();
    },
  },
  mounted() {
    const chartDom = document.querySelector(".clickCharts");
    this.myChart = echarts.init(chartDom);
    this._getDatas(7);
  },
  methods: {
    _getDatas(dataLength) {
      dataLength = Number(dataLength);
      this.option.xAxis.data = new Array(dataLength)
        .fill(0)
        .map((_, index) => {
          const date = new Date(Date.now() - index * 1000 * 60 * 60 * 24);
          return "" + Number(date.getUTCMonth() + 1) + "-" + date.getUTCDate();
        })
        .reverse();
      getDays(dataLength).then((res) => {
        this.option.series[0].data = res.data;

        this._setData();
      });
    },
    _setData() {
      this.myChart.setOption(this.option);
      this.onResize();
    },
    onResize() {
      this.myChart.resize();
    },
  },
};
</script>

<style lang="less" scoped>
.clickNum {
  border-radius: 10px;
  margin: 1rem 0;
  padding: 2rem;
  width: calc(60vw + 2rem);
  // flex: 1;
  /* transition: none; */
  background: #fff;
  .tools {
    display: flex;
    justify-content: space-between;
    .title {
      font-size: 1.4rem;
      // font-weight: 600;
      opacity: 0.9;
    }
    .tool-select {
      appearance: none;
      background: #f9fbff;
      // background: url("http://ourjs.github.io/static/2015/arrow.png") no-repeat
      //   scroll right center transparent;
      -moz-appearance: none;
      color: #7e7e7e;
      -webkit-appearance: none;
      border: none;
      outline: none;
      padding: 0.5rem 1rem;
      border-radius: 10px;
      option {
        border: none;
        outline: none;
      }
    }
  }
}
.clickCharts {
  width: 60vw;
  height: 300px;
  transition: none;
}
</style>
